<section class="animated fadeIn bgWhite">
  <div class="gradBg"></div>
  <div class="container pRelativ">
    <div class="headerBredcrm justify-content-between align-items-center mt-20 mb-10">
      <div class="leftSide">
        <p class="bredcrm">Dashboard</p>
      </div>
      <div class="rightSide glb-btn">
        <button class="btn secondry-button" routerLink="/quick-deligation">Create New Request</button>
      </div>
    </div>
  </div>
  <div class="container pRelativ">
    <div class="row tabTable">
      <tabset>
        <tab class="requestTab" (selectTab)="changeTab()">
          <ng-template tabHeading> My Approvals ({{totalRows}}) </ng-template>
          <div class="slider" [hidden]="hiddenBtn || IstopFiveApprovalData" [ngClass]="navigationApprove()">
            <carousel class="slide-animated" [itemsPerSlide]="itemsPerSlide" [singleSlideOffset]="singleSlideOffset"
              [noWrap]="!noWrap" [interval]="false" [startFromIndex]="0" [isAnimated]="true">
              <slide class="animated fadeIn" *ngFor="let approvalSlider of roleByAppSlider; let i=index">
                <div class="cardCars">
                  <div class="cell iconS"><i class="hdr-aam"></i></div>
                  <!-- <div class="cell iconS"><i [ngClass]="{ 
                    'hdr-lms-2':approvalSlider.ApplicationCode==='LMS',
                    'hdr-iTime1':approvalSlider.ApplicationCode==='iTime',
                    'hdr-iBridge':approvalSlider.ApplicationCode==='iBridge',
                    'hdr-gcs':approvalSlider.ApplicationCode==='GCS',
                    'hdr-transportal':approvalSlider.ApplicationCode==='My Travels',
                    'hdr-tas':approvalSlider.ApplicationCode==='TAS',
                    'hdr-myApproval':approvalSlider.ApplicationCode==='My Approvals',
                    'hdr-smartSurvey':approvalSlider.ApplicationCode==='Smart Survey',
                    'hdr-ssd':approvalSlider.ApplicationCode==='SSD',
                    'hdr-aam':approvalSlider.ApplicationCode==='AAM'}"></i></div>  -->
                  <div class="cell">
                    <h4>{{approvalSlider.ApplicationDescription}}</h4>
                    <p>
                      <span class="sText action">{{approvalSlider.RoleName}}</span>
                      <span class="sText action">{{approvalSlider.SubRoleName}}</span>
                    </p>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="d-flex justify-content-between mt-24 mb-16 align-items-center" style="padding-top: 4.5px;">
            <div class="leftSide">
              <h4 class="f-18 robertS" [hidden]="IstopFiveApprovalData">My Pending Approvals </h4>
            </div>
            <div class="rightSide" [hidden]="IstopFiveApprovalData">
              <div class="rightIcon">
                <ul class="d-flex align-items-center mb-0">
                  <li>
                    <button (click)="viewllMyApproval()"><span *ngIf="viewLessMyApproval === false">View All</span>
                      <span *ngIf="viewLessMyApproval == true">View Less</span></button>
                  </li>
                  <li class="searchProject FormField2 lineIffect">
                    <div class="posRel empSearch">
                      <p-autoComplete [(ngModel)]="delegateegridTextvalue" ngDefaultControl
                        [suggestions]="filteredGridBrands" (completeMethod)="filterGridBrands($event)" [size]="30"
                        [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"
                        (onKeyUp)="onClickDelegateonKeyUp($event)" (onSelect)="OnSelectApproverGrid($event)">
                      </p-autoComplete>
                      <i class="icon-search"></i>
                    </div>
                  </li>
                  <li tooltip="Filter" placement="top" container="body" class="mr-0"><i (click)="visibleSidebar1 = true"
                      class="icon-filter"></i></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="customTable" [hidden]="hiddenBtn || IstopFiveApprovalData">
            <div class="tableHeader">
              <div class="table-row">
                <div class="tabel-div w-28">
                  <div class="table-cell w-35">
                    <label class="checkbox-label">
                      <input type="checkbox" class="check1" [(ngModel)]="isCheckedHeader" ngDefaultControl
                        (change)="maincheckbox(isCheckedHeader?'A':'B')">
                      <span class="checkbox-custom"></span> <span class="checkText tableHd">Request ID</span> </label>
                  </div>
                  <div class="table-cell w-65">Application/Role</div>
                </div>
                <div class="tabel-div w-40">
                  <div class="table-cell w-30">Delegator/SAP ID</div>
                  <div class="table-cell w-30">Delegatee /SAP ID</div>
                  <div class="table-cell w-40">Duration/Days</div>
                </div>
                <div class="tabel-div w-28">
                  <div class="table-cell w-22">Remarks</div>
                  <div class="table-cell w-37">Mailer Restricted</div>
                  <div class="table-cell w-40">Download</div>
                </div>
                <div class="tabel-div w-6 justify-content-center">
                  <div class="table-cell w-100 text-center">Action</div>
                </div>
              </div>
            </div>
            <div class="tableBody" *ngFor="let request of topFiveApprovalData;let i=index">
              <div class="table-row">
                <div class="tabel-div w-28">
                  <div class="table-cell w-35">
                    <label class="checkbox-label">
                      <input type="checkbox" class="check1" [checked]="gridcheckval"
                        (change)="maincheckboxDelreqId($event,request.Del_ReqId)"> <span class="checkbox-custom"></span>
                      <span class="checkText tableHd">{{request.Del_ReqId}}</span> </label>
                  </div>
                  <div class="table-cell w-65">
                    <!-- <div class="upText nameCellElli" tooltip="{{request.ApplicationDescription}}" container="body"
                      placement="top">{{request.ApplicationDescription | titlecase}}</div> -->
                      <div class="upText nameCellElli" container="body" triggers="mouseenter:mouseleave"
                      placement="top" [popover]="appDescTemp">{{request.ApplicationDescription | titlecase}}</div>
                      <ng-template #appDescTemp>
                        <div class="Revoke provideDiv">
                          {{request.ApplicationDescription}}
                        </div>
                    </ng-template>
                    <div class="boText" *ngIf="request?.SubRole?.length == 0">{{request.RoleName}}</div>
                    <div class="boText" *ngIf="request?.SubRole?.length>0">{{request.RoleName}} <span>
                        <a class="boText" *ngIf="request?.SubRole?.length >= 1" triggers="mouseenter:mouseleave"
                          placement="bottom" container="body" (click)="shareTemplate.toggle($event)"
                          href="javaScript:void(0)"> | {{request.SubRole[0].SubRoleName}} </a>
                        <i class="hdr-shear-link" *ngIf="request?.SubRole?.length>1"></i></span>
                      <p-overlayPanel #shareTemplate>
                        <div class="roles">
                          <h4>Sub-Roles</h4>
                          <p class="popoverText" *ngFor="let subrole of request.SubRole;let i=index">
                            {{subrole.SubRoleName}}</p>
                        </div>
                      </p-overlayPanel>
                    </div>
                  </div>
                </div>
                <div class="tabel-div w-40">
                  <div class="table-cell w-30">
                    <!-- <div class="upText nameCellElli" tooltip="{{request.RequesterName}}" container="body"
                      placement="top">{{request.RequesterName | titlecase}}</div> -->
                      <div class="upText nameCellElli" container="body" triggers="mouseenter:mouseleave"
                      placement="top" [popover]="requesterNameTemp">{{request.RequesterName | titlecase}}</div>
                      <ng-template #requesterNameTemp>
                        <div class="Revoke provideDiv">
                          {{request.RequesterName | titlecase}}
                        </div>
                    </ng-template>
                    <div class="boText">({{request.RequesterSAPId}})</div>
                  </div>
                  <div class="table-cell w-30">
                    <!-- <div class="upText nameCellElli" tooltip="{{request.DelegateeName}}" container="body"
                      placement="top">{{request.DelegateeName | titlecase}} </div> -->
                      <div class="upText nameCellElli" container="body" triggers="mouseenter:mouseleave"
                      placement="top" [popover]="delegateeNameTemp">{{request.DelegateeName | titlecase}}</div>
                      <ng-template #delegateeNameTemp>
                        <div class="Revoke provideDiv">
                          {{request.DelegateeName | titlecase}}
                        </div>
                    </ng-template>
                    <div class="boText">({{request.DelegateeSAPId}})</div>
                  </div>
                  <div class="table-cell w-40">
                    <div class="upText">{{request.DelegationStartDate | date:'d-MMM-yy'}} to
                      {{request.DelegationEndDatetime | date:'d-MMM-yy'}}</div>
                    <div class="boText">({{calcluateDateDiff(request.DelegationEndDatetime,
                      request.DelegationStartDate)}} Days)</div>
                  </div>
                </div>
                <div class="tabel-div w-28">
                  <div class="table-cell w-22">
                    <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom"
                          container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i
                            class="hdr-chat"></i></a></span>
                      <p-overlayPanel #chatTemplate >
                        <div class="roles">
                          <p class="popoverText mt-m5">{{request.Remarks}}</p>
                        </div>
                      </p-overlayPanel>
                    </div>
                  </div>
                  <div class="table-cell w-37">
                    <div class="bages reject" *ngIf="(request.MailerRequired == false)">No</div>
                    <div class="bages approve" *ngIf="(request.MailerRequired == true)">Yes</div>
                  </div>
                  <div class="table-cell w-47" *ngIf="request.DocumentId > 0" style="cursor: pointer;">
                    <!-- <a href="../../../assets/images/sample-PDF.pdf" download="" class="attachmentLink"> <span class="hdr-attachment-normal f-16"></span> Attachme… .png</a> -->                   
                      <!-- <div class="upText nameCellElli" tooltip="{{request.DocumentPath}}" container="body"
                      placement="top"> <a download="" class="attachmentLink" (click)="downloadFile(request.DocumentId,request.DocumentPath,$event);">
                        <span class="hdr-attachment-normal f-16"></span>{{request.DocumentPath}}</a></div> -->
                      <div class="upText nameCellElli" container="body" triggers="mouseenter:mouseleave"
                      placement="top" [popover]="documentNameTemp">
                      <a download="" class="attachmentLink" (click)="downloadFile(request.DocumentId,request.DocumentPath,$event);">
                        <span class="hdr-attachment-normal f-16"></span>{{request.DocumentPath}}</a></div>
                      <ng-template #documentNameTemp>
                        <div class="Revoke provideDiv">
                          {{request.DocumentPath}}
                        </div>
                    </ng-template>                   
                      
                  </div>
                </div>
                <div class="tabel-div w-6">
                  <div class="table-cell W-100 actionWarp">
                    <a href="javaScript:void(0)" class="" (click)="onApproveRequest(request.Del_ReqId);"> <span
                      [popover]="approvePopoverTemp" triggers="mouseenter:mouseleave" container="body" placement="top" class="hdr-checklist"></span></a>
                    <a href="javaScript:void(0)" class="" (click)="rejectModal.show();onReject(request.Del_ReqId)">
                      <span  [popover]="rejectPopoverTemp" triggers="mouseenter:mouseleave" container="body" placement="top" class="hdr-referback"></span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ctaBtnWarp d-flex justify-content-center mt-24 glb-btn pos-sticky mr--5 border-t-1-gray" style="padding-top: 24px; margin-left: -615px; margin-right: -615px;">
            <button [hidden]="hiddenBtn || IstopFiveApprovalData" (click)="checkRejectselect();onBulkReject()"
              type="button" class="btn secondry-button">Reject</button>
            <!-- <button (click)="openModal(alertModal)" type="button" class="btn secondry-button">Alert</button> -->
            <button [hidden]="hiddenBtn || IstopFiveApprovalData" (click)="bulkApprove();" type="button"
              class="btn primary-button">Approve</button>
          </div>
          <div class="customTable" *ngIf="IstopFiveApprovalData" style="margin-top: 130px;">
            <div class="noRecored">
              <div class="norecoredContent">
                <img src="../../../assets/images/icon.png" alt="" class="">
                <h4>No Data Found</h4>
              </div>
            </div>
          </div>
        </tab>
        <tab class="initiateTab pb-24" (selectTab)="changeTab()">
          <ng-template tabHeading> My Request ({{totalRequestRows}}) </ng-template>
          <div [ngClass]="navigation()" class="slider" [hidden]="IstopFiveMyRequestData">
            <carousel [itemsPerSlide]="itemsPerSlideRequest" [singleSlideOffset]="singleSlideOffset" [noWrap]="!noWrap"
              [interval]="false" [startFromIndex]="0">
              <slide class="animated fadeIn" *ngFor="let requestSlider of roleByAppSliderMyRequest;let i=index ">
                <div class="cardCars">
                  <div class="cell iconS"><i class="hdr-aam"></i></div>
                  <!-- <div class="cell iconS"><i [ngClass]="{ 
                    'hdr-lms-2':requestSlider.ApplicationCode==='LMS',
                    'hdr-iTime1':requestSlider.ApplicationCode==='iTime',
                    'hdr-iBridge':requestSlider.ApplicationCode==='iBridge',
                    'hdr-gcs':requestSlider.ApplicationCode==='GCS',
                    'hdr-transportal':requestSlider.ApplicationCode==='My Travels',
                    'hdr-tas':requestSlider.ApplicationCode==='TAS',
                    'hdr-myApproval':requestSlider.ApplicationCode==='My Approvals',
                    'hdr-smartSurvey':requestSlider.ApplicationCode==='Smart Survey',
                    'hdr-ssd':requestSlider.ApplicationCode==='SSD',
                    'hdr-aam':requestSlider.ApplicationCode==='AAM'}"></i></div> -->
                  <div class="cell">
                    <h4>{{requestSlider.ApplicationDescription}}</h4>
                    <p>
                      <span class="sText action">{{requestSlider.RoleName}}</span>
                      <span class="sText action">{{requestSlider.SubRoleName}}</span>
                    </p>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="d-flex justify-content-between mt-24 mb-16 align-items-center" style="padding-top: 4.5px;">
            <div class="leftSide">
              <h4 class="f-18 robertS" [hidden]="IstopFiveMyRequestData">My Requests</h4>
            </div>
            <div class="rightSide" [hidden]="IstopFiveMyRequestData">
              <div class="rightIcon">
                <ul class="d-flex align-items-center mb-0">
                  <li>
                    <button (click)="viewll()">
                      <span *ngIf="viewLess === false">View All</span>
                      <span *ngIf="viewLess == true">View Less</span>
                    </button>
                  </li>
                  <li class="searchProject FormField2 lineIffect">
                    <div class="posRel empSearch">
                      <p-autoComplete [(ngModel)]="delegateegridTextvalue" ngDefaultControl
                        [suggestions]="filteredGridBrands" (completeMethod)="filterGridBrands($event)" [size]="30"
                        [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"
                        (onKeyUp)="onClickDelegateonKeyUp($event)" (onSelect)="OnSelectRequestorGrid($event)">
                      </p-autoComplete>
                      <i class="icon-search"></i>
                    </div>
                  </li>
                  <li tooltip="Filter" placement="top" container="body" class="mr-0"><i (click)="visibleSidebar2 = true"
                      class="icon-filter"></i></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="customTable" *ngFor="let myRequests of topFiveMyRequestData;let i=index">
            <div class="tableBody">
              <div class="table-row2">
                <div class="tableCardHeader d-flex justify-content-between">
                  <h4>{{myRequests.ApplicationDescription}}</h4>
                  <div class="bages pennding" *ngIf="(myRequests.RequestStatus ==='Pending RM Approval')">Pending</div>
                  <div class="bages pennding" *ngIf="(myRequests.RequestStatus ==='Pending L3 Delivery Head Approval')">
                    Pending</div>
                  <div class="bages pennding"
                    *ngIf="(myRequests.RequestStatus ==='Pending Second Level Manager Approval')">Pending</div>
                  <div class="bages reject" *ngIf="(myRequests.RequestStatus === 'Rejected')">Reject</div>
                  <div class="bages approve" *ngIf="(myRequests.RequestStatus === 'Approved')">Approved</div>
                  <div class="bages reject" *ngIf="(myRequests.RequestStatus === 'Cancelled')">Cancelled</div>
                </div>
                <div class="tableDivWarp">
                  <div class="tabel-div w-100">
                    <div class="table-cell w-12">
                      <label for="" class="customLabel">Request ID</label>
                      <p class="labelFor">{{myRequests.Del_ReqId}}</p>
                    </div>
                    <div class="table-cell w-20">
                      <label for="" class="customLabel">Delegatee /SAP ID</label>
                      <p class="labelFor">{{myRequests.DelegateeName|titlecase}}
                        ({{myRequests.DelegateeSAPId}})</p>
                    </div>
                    <div class="table-cell w-20">
                      <label for="" class="customLabel">Role</label>
                      <div class="boText" *ngIf="myRequests?.SubRole?.length==0">{{myRequests.RoleName}} </div>
                      <div class="boText" *ngIf="myRequests?.SubRole?.length>0">{{myRequests.RoleName}}<span>
                          <a class="boText" *ngIf="myRequests?.SubRole?.length >= 1" triggers="mouseenter:mouseleave"
                            placement="bottom" container="body" (click)="shareTemplate.toggle($event)"
                            href="javaScript:void(0)"> | {{ myRequests.SubRole[0].SubRoleName}} </a>
                          <i class="hdr-shear-link" *ngIf="myRequests?.SubRole?.length>1"></i></span>
                        <p-overlayPanel #myRequestShareTemplate>
                          <div class="roles">
                            <h4>Sub-Roles</h4>
                            <p class="popoverText" *ngFor="let myReqSubRole of myRequests.SubRole;let i=index">
                              {{myReqSubRole.SubRoleName}}</p>
                          </div>
                        </p-overlayPanel>
                      </div>
                    </div>
                    <div class="table-cell w-25">
                      <label for="" class="customLabel">Duration/Days</label>
                      <p class="labelFor">{{myRequests.DelegationStartDate | date:'d-MMM-yy'}} to
                        {{myRequests.DelegationEndDatetime | date:'d-MMM-yy'}}
                        ({{calcluateDateDiff(myRequests.DelegationEndDatetime,myRequests.DelegationStartDate)}} Days)
                      </p>
                    </div>
                    <div class="table-cell w-20">
                      <label for="" class="customLabel">Pending On</label>
                      <p class="labelFor">{{myRequests.ApproverName|titlecase}} ({{myRequests.ApproverSAPId}})</p>
                    </div>
                    <div class="table-cell w-3 last-cell"
                      *ngIf=" (myRequests.RequestStatus!=='Cancelled' && myRequests.RequestStatus!=='Rejected' && calcluateDateDiff(myRequests.DelegationEndDatetime, deploymentTime|date) > 0)">
                      <button (click)="cancelModal.show();setCancelReqId(myRequests)" class="requestCancleBtn"><i
                          tooltip="Cancel" class="hdr-cancel"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="customTable" *ngIf="IstopFiveMyRequestData" style="margin-top: 160px;">
            <div class="noRecored">
              <div class="norecoredContent">
                <img src="../../../assets/images/icon.png" alt="" class="">
                <h4>No Data Found</h4>
              </div>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</section>

<!-- along Approve Popover info  -->
<ng-template #approvePopoverTemp>
  <div class="Revoke provideDiv">
      Approve
  </div>
</ng-template>

<!-- along with Reject Popover info  -->
<ng-template #rejectPopoverTemp>
  <div class="Revoke provideDiv">
      Reject
  </div>
</ng-template>

<!-- Filter for My approvals-->
<p-sidebar class="filter" [(visible)]="visibleSidebar1" position="right" [style]="{width:'340px'}">
  <div class="filter-body">
    <h3>Filter <button class="close" aria-label="close filter" (click)="visibleSidebar1 = false"><i
          class="icon-cancel"></i></button> </h3>
    <div class="FormField">
      <label>Employee Search (Name / SAP ID)</label>
      <div class="posRel FormField2">
        <p-autoComplete [(ngModel)]="delegateeTextvalue" ngDefaultControl [suggestions]="filteredBrands"
          (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID"
          panelStyleClass="panelClass" (onKeyUp)="textValue($event)" (onSelect)="updateDelegateeId($event)">
        </p-autoComplete>
        <i class="icon-search"></i>
      </div>
    </div>
    <div class="FormField">
      <label>Application</label>
      <p-dropdown placeholder="Search" [options]="mypendingApplication" [(ngModel)]="pendingapplicationList"
        ngDefaultControl></p-dropdown>
    </div>
    <div class="FormField">
      <label>Role</label>
      <p-dropdown placeholder="Search" [options]="mypendingRole" [(ngModel)]="mypendingroleName" ngDefaultControl>
      </p-dropdown>
    </div>
    <div class="FormField mb-0">
      <label>Status</label>
      <p-dropdown placeholder="Search" [options]="PendingStatus" [(ngModel)]="RequestStatus" ngDefaultControl>
      </p-dropdown>
    </div>
    <div class="text-center glb-btn mt-16">
      <button class="btn secondry-button" (click)="ClearData()">Reset</button>
      <button class="btn primary-button" (click)="onMyRequestSearch(); visibleSidebar1 = false">Apply</button>
    </div>
  </div>
  <!-- </div> -->
</p-sidebar>

<!-- Filter for My Requests-->
<p-sidebar class="filter" [(visible)]="visibleSidebar2" position="right" [style]="{width:'340px'}">
  <div class="filter-body">
    <h3>Filter <button class="close" aria-label="close filter" (click)="visibleSidebar2 = false"><i
          class="icon-cancel"></i></button> </h3>
    <div class="FormField">
      <label>Employee Search (Name / SAP ID)</label>
      <div class="posRel FormField2">
        <p-autoComplete [(ngModel)]="delegateeTextvalue" ngDefaultControl [suggestions]="filteredBrands"
          (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID"
          panelStyleClass="panelClass" (onKeyUp)="textValue($event)" (onSelect)="updateDelegateeId($event)">
        </p-autoComplete>
        <i class="icon-search"></i>
      </div>
    </div>
    <div class="FormField">
      <label>Application</label>
      <p-dropdown placeholder="Search" [options]="application" [(ngModel)]="applicationList" ngDefaultControl>
      </p-dropdown>
    </div>
    <div class="FormField">
      <label>Role</label>
      <p-dropdown placeholder="Search" [options]="Role" [(ngModel)]="RoleName" ngDefaultControl></p-dropdown>
    </div>
    <div class="FormField mb-0">
      <label>Status</label>
      <p-dropdown placeholder="Search" [options]="Status" [(ngModel)]="RequestStatus" ngDefaultControl></p-dropdown>
    </div>
    <div class="text-center glb-btn mt-16">
      <button class="btn secondry-button" (click)="ClearData()">Reset</button>
      <button class="btn primary-button" (click)="onSearch(); visibleSidebar2 = false">Apply</button>
    </div>
  </div>
  <!-- </div> -->
</p-sidebar>


<!-- Alert Modal Box Start  -->
<ng-template #alertModal>
  <div class="modal-body successModal">
    <button type="button" class="btn-close close pull-right" aria-label="Close"
      (click)="modalRef?.hide(); hideSuccessMsg()">
    </button>
    <div class="mtable">
      <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
      <p class="">This is a message that is just for <br>information.</p>
    </div>
  </div>
</ng-template>


<!-- Approve Modal Box Start  -->
<ng-template #approvedModal>
  <div class="modal-body successModal">
    <button type="button" class="btn-close close pull-right" aria-label="Close"
      (click)="modalRef?.hide(); hideSuccessMsg()">
    </button>
    <div class="mtable">
      <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
      <p class="">Request has been approved successfully.</p>
    </div>
  </div>
</ng-template>

<!-- Reject Modal Box Start  -->
<div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Rejection Remarks</h4>
        <button type="button" class="btn-close close pull-right" (click)="rejectModal.hide()" aria-label="Close">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-area text-center">
          <textarea (keyup)="rejMessage()" [(ngModel)]="rejectRemarks" ngDefaultControl appChar maxlength="100"
            class="form-control remarks" placeholder="Please enter remarks" rows="4" cols="4"></textarea>
          <div class="mickWarp"><span class="hdr-mick"></span></div>
        </div>
        <!-- <div class="error-msz" *ngIf="activeSubmitButton">*Please enter remarks</div> -->
        <div class="glb-btn mt-20">
          <button [disabled]="!rejectRemarks" type="button" class="btn primary-button"
            (click)="rejectModal.hide(); onRejectRequest();">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Bulk Reject Modal Box Start  -->
<div bsModal #rejectbulkModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Rejection Remarks</h4>
        <button type="button" class="btn-close close pull-right" (click)="rejectbulkModal.hide()" aria-label="Close">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-area text-center">
          <textarea class="form-control remarks" appChar maxlength="100" [(ngModel)]="rejectBulkRemarks"
            ngDefaultControl (keyup)="rejMessage()" placeholder="Please enter remarks" rows="4" cols="4"></textarea>
          <div class="mickWarp"><span class="hdr-mick"></span></div>
        </div>
        <!-- <div class="error-msz" *ngIf="activeSubmitButton">*Please enter remarks</div> -->
        <div class="glb-btn mt-20">
          <button [disabled]="!rejectBulkRemarks" type="button" class="btn primary-button"
            (click)="rejectbulkModal.hide(); bulkReject();">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reject Modal Box Start  -->
<ng-template #rejectTempModal>
  <div class="modal-body successModal">
    <button type="button" class="btn-close close pull-right" aria-label="Close"
      (click)="modalRef?.hide(); hideSuccessMsg()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <div class="mtable">
      <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
      <p class="">Request has been rejected successfully.</p>
    </div>
  </div>
</ng-template>

<!-- cancel Modal Box Start  -->
<div bsModal #cancelModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Cancellation Remarks</h4>
        <button type="button" class="btn-close close pull-right" (click)="cancelModal.hide()" (keyup)="cancelMsg()"
          aria-label="Close">
          <!-- <span aria-hidden="true" class="visually-hidden">&times;</span> -->
        </button>
      </div>
      <div class="modal-body">
        <div class="form-area text-center">
          <textarea class="form-control remarks" placeholder="Please enter remarks" rows="4" cols="4" (keyup)="cancelMsg()"
            [(ngModel)]="cancelRemarks" ngDefaultControl></textarea>
          <div class="mickWarp"><span class="hdr-mick"></span></div>
        </div>
        <!-- <div class="error-msz" *ngIf="activeCancelBtn">*Please enter remarks</div> -->
        <div class="glb-btn mt-20">
          <button [disabled]="!cancelRemarks" type="button" class="btn primary-button"
            (click)="cancelModal.hide(); OnCancelRequest();">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reject Request Delete Modal Box Start  -->
<div bsModal #rejectModal2="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body d-flex justify-content-center">
        <div class="mCell text-center">
          <span class="alertIcon"> <i class="hdr-attention"></i> </span>
          <h3>Are you sure you want to delete request?</h3>
          <div class="glb-btn mt-20">
            <button (click)="rejectModal2.hide();" class="btn secondry-button">No</button>
            <button type="button" class="btn primary-button"
              (click)="rejectModal2.hide();">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--  Reject Request Delete successfully  Modal Box Start  -->
<ng-template #cancelTempModal>
  <div class="modal-body successModal">
    <button type="button" class="btn-close close pull-right" aria-label="Close"
      (click)="modalRef?.hide(); hideSuccessMsg()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <div class="mtable">
      <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
      <p class="">Request has been cancelled successfully.</p>
    </div>
  </div>
</ng-template>



<!--will create if condition my default it will
              b hide on click it will toggle--->
<ng-container *ngIf="visible">
  <div class="toast-warp" #deev>
    <p> Please provide delegator consent. </p>
    <button (click)="deev.hidden = !deev.hidden" type="button" aria-label="Close"
      class="btn-close close pull-right"><span aria-hidden="true"></span></button>
  </div>
</ng-container>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>